export type InsightsMetricState = 'ready' | 'error' | 'empty' | 'empty-period' | 'below-guardrail'

export type InsightsEmptyMetricState = Exclude<InsightsMetricState, 'ready' | 'error'>

export const STATE_KEYS: Record<InsightsEmptyMetricState, string> = {
  empty: 'empty',
  'empty-period': 'emptyPeriod',
  'below-guardrail': 'belowGuardrail',
}

type BatchItemLike = { status?: number | null; error?: string | null; response?: { emptyReason?: string | null } | null } | undefined

export const metricState = (item: BatchItemLike, rowCount: number): InsightsMetricState => {
  if (!item || item.status !== 200 || item.error) return 'error'
  if (item.response?.emptyReason === 'BELOW_GUARDRAIL') return 'below-guardrail'
  if (rowCount > 0) return 'ready'
  return item.response?.emptyReason === 'NO_DATA_FOR_PERIOD' ? 'empty-period' : 'empty'
}

export const requestState = (item: BatchItemLike): InsightsMetricState => (!item || item.status !== 200 || item.error ? 'error' : 'ready')
